module.exports = __webpack_public_path__ + "img/dfod_dg_k.5d2b546f.png";